import React, { PropTypes } from 'react'
import IconBackarrow from 'icons/IconBackarrow'
import styles from './BackTo.scss'

const BackTo = ({ displayText, history }) => {
  if (displayText) {
    return (
      <div className={styles.wrapper}>
        <IconBackarrow onClick={() => history.goBack()} className={styles.BackImage} />
        <span className={styles.Heading}>{displayText}</span>
      </div>
    )
  }
  return (<div />)
}

BackTo.propTypes = {
  displayText: PropTypes.string,
  history: PropTypes.object.isRequired,
}

BackTo.defaultProps = {
  displayText: '',
}

export default BackTo



// WEBPACK FOOTER //
// ./src/components/BackTo/BackTo.js